import React from 'react';
import './DividerAccentLine.css';

/**
 * DividerAccentLine - A simple, clean accent line divider
 *
 * Features:
 * - Centered thin horizontal line in lavender/purple
 * - Small decorative diamond in the center
 * - White/light background
 * - Minimal and elegant design
 */
const DividerAccentLine = () => {
  return (
    <div className="divider-accent-line">
      <div className="divider-accent-line__container">
        <span className="divider-accent-line__segment"></span>
        <span className="divider-accent-line__diamond"></span>
        <span className="divider-accent-line__segment"></span>
      </div>
    </div>
  );
};

export default DividerAccentLine;
